export default "__VITE_ASSET__08955756__"